import { render, staticRenderFns } from "./DownloadCenterBottomBar.vue?vue&type=template&id=14376de9&"
import script from "WX/components/Download/DownloadCenterBottomBar.component?vue&type=script&lang=js&"
export * from "WX/components/Download/DownloadCenterBottomBar.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports